angular.module('esn.mailto-handler')
  .constant('MAILTOHANDLER_CONSTANTS', {
    windowWidth: 800,
    windowHeight: 600
  });
